import 'Modernizr'
import 'alpinejs'
import 'lazysizes'

const init = require('./init')

document.addEventListener("DOMContentLoaded", function() {
	init.run();
});

//Fix the back button by forcing it to reload the page
window.addEventListener('popstate', function(event) {
    history.go();
}, false);
